import React from 'react';
import { Menu, Plus } from 'lucide-react';
import SimplizeLogo from '../../components/SimplizeLogo';
import SessionShareButton from '../../components/SessionShareButton';
import { isAuthenticated } from '../../utils/api';
import { useChatPlatform } from '../context/ChatPlatformContext';
import { useSessions } from '../store/hooks';

export default function MobileHeader({
    isShareView,
    sharedInfo,
    isAdminView,
    isDraftChat,
    messages,
    liveMessages,
    isLoading,
    isInputDisabled,
    handleNewChat,
}) {
    const {
        isMobile,
        isSidebarOpen,
        setIsSidebarOpen,
        activeSessionId,
        isStreaming,
    } = useChatPlatform();
    const sessions = useSessions();

    if (!(isMobile && isAuthenticated())) return null;

    const activeSession = sessions.find(s => s.session_id === activeSessionId);
    const title = isShareView
        ? (sharedInfo?.title || sharedInfo?.session_name || (isAdminView ? 'Admin View' : 'Shared Chat'))
        : (activeSession?.session_name || <SimplizeLogo className="h-6 w-auto" />);

    const showShareButton =
        (activeSessionId || isShareView) &&
        !isDraftChat &&
        !(isStreaming && messages.length === 0 && liveMessages.length <= 1);

    return (
        <div className="fixed top-0 left-0 right-0 z-20 bg-app-bg h-14 chat-header">
            <div className="w-full max-w-3xl mx-auto flex items-center justify-between px-2 sm:px-6 h-full">
                <button
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    className="p-2 sm:p-2 text-gray-500 hover:text-black hover:bg-app-hover rounded-full"
                >
                    <Menu className="w-5 h-5" />
                </button>

                <span className="font-semibold text-gray-800 truncate px-2">
                    {title}
                </span>

                <div className="flex items-center gap-1">
                    {showShareButton && (
                        <SessionShareButton
                            sessionId={activeSessionId || sharedInfo?.session_id}
                            sessionName={activeSession?.session_name || 'Chat Session'}
                            size="md"
                            className="p-2 text-gray-700 hover:bg-app-hover rounded-full transition-colors duration-200"
                            disabled={isShareView}
                        />
                    )}
                    <button
                        onClick={handleNewChat}
                        className="p-2 sm:p-2 text-gray-700 transition-colors duration-200"
                        disabled={isLoading || isInputDisabled}
                    >
                        <div className="w-5 h-5 rounded-full bg-brand-blue-500 hover:bg-brand-blue-600 active:bg-brand-blue-600 flex items-center justify-center transition-colors duration-200">
                            <Plus className="w-3 h-3 text-white" />
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
}
